import React, {useEffect, useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  Avatar,
  Badge,
  Box,
  Chip,
  darken,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Theme,
  Toolbar,
  Typography,
} from '@mui/material';
import Strings from "../assets/strings";

import {
  ArrowBack,
  ExitToApp,
  Menu as MenuIcon,
  NotificationsActiveOutlined,
  NotificationsNone,
  PersonOutline,
  WhatsApp
} from '@mui/icons-material';
import {setOpenWsBotModal, toggleDrawer, toggleNotifSide} from "../redux/reducers/themeReducer";
import {useAppDispatch, useAppSelector} from '../redux/hooks';

import AppBar from '@mui/material/AppBar';
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import Routes from "../routes";
import {userLogout} from "../redux/reducers/authReducer";
import {hasModule, hasPermissionTo, PERSMISOS, translateText} from "../helpers";
import {MODULO_USUARIO} from "../helpers/CONSTANTES";

const useStyles = makeStyles((theme:Theme) => ({
  root: {
    position: 'fixed',
    width: "100%",
    boxShadow: "none",
    "& *":{
      outline: "none",
      border:"none",
      color: theme.palette.common.white,
    },
    "& option":{
      color: theme.palette.common.black,

    },
  },
  toolbar:{
    padding: "0px "+theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      paddingLeft: 0
    },
  },
  appName:{
    height: "49px",
    background: darken(theme.palette.primary.main,0.1),
    marginRight: "10px",
    display: "flex",
    alignItems: "center",
    width: "241px",
    fontSize: "19px",
    paddingLeft: "16px",
    boxSizing: "border-box",
    overflow: "hidden",
    transition: "width 0.2s",
    [theme.breakpoints.down('md')]: {
      display: "none"
    },
    "&.hide":{
      width: 88,
    }
  },
  under:{
    boxShadow: "none",
    [theme.breakpoints.up('md')]: {
      top:50,
      padding: "7px 4px",
      width: "inherit",
      backgroundColor: "white",
      borderBottom: "1px solid rgba(0,0,0,0.1)",
      color: "inherit",
      "& + .contentInner":{
        marginTop: 65
      },
    },
   // [theme.breakpoints.down('md')]: {
      "& *":{
        outline: "none",
        border:"none",
        color: theme.palette.common.white,
      },
      "& option":{
        color: theme.palette.common.black,

      }
    //},

  },

  toggleBtn:{
    marginRight:theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      cursor:"pointer"
      //display: "none",
    },
  },
  title: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    fontSize:"1.25rem",
    fontWeight: 400,
    textTransform:"capitalize",
    "& button":{
      marginRight: theme.spacing(1),
    }
  },
  accountBtn:{
    background: darken(theme.palette.primary.main,0.1),
    "&.active":{
      background:darken(theme.palette.secondary.main,0.1),
    },
    borderRadius:"5px !important",
      "& .MuiAvatar-root":{
        backgroundColor:"transparent"
      },
    [theme.breakpoints.down('sm')]: {
      "& .MuiChip-label":{
        padding: 5,
        "& div":{
          display:"none"
        }
      }
    },
  },
}));
// const useStyles = makeStyles((theme:Theme) => ({
//   root: {
//     position: 'fixed',
//     width: "100%",
//     boxShadow: "none",
//     [theme.breakpoints.up('md')]: {
//       //top:50,
//       padding: "7px 4px",
//       width: "inherit",
//       backgroundColor: lighten(theme.palette.primary.main,0.8),//"#f2f2f2",
//       //borderBottom: "1px solid rgba(0,0,0,0.1)",
//       color: "inherit",
//       // "& + .contentInner":{
//       //   marginTop: 15
//       // },
//     },
//     [theme.breakpoints.down('md')]: {
//       "& *":{
//         outline: "none",
//         border:"none",
//         color: theme.palette.common.white,
//       },
//       "& option":{
//         color: theme.palette.common.black,
//
//       }
//     },
//
//   },
//   toolbar:{
//     padding: "0px "+theme.spacing(2),
//   },
//   accountBtn:{
//     borderRadius:"5px !important",
//     [theme.breakpoints.down('sm')]: {
//       "& .MuiChip-label":{
//         padding: 5,
//         "& div":{
//           display:"none"
//         }
//       }
//     },
//   },
//   toggleBtn:{
//     padding:0,
//     marginRight:theme.spacing(2),
//     [theme.breakpoints.up('md')]: {
//       cursor:"pointer"
//       //display: "none",
//     },
//   },
//   title: {
//     display: "flex",
//     alignItems: "center",
//     flex: 1,
//     fontSize:"1.25rem",
//     fontWeight: 400,
//     textTransform:"capitalize",
//     "& button":{
//       marginRight: theme.spacing(1),
//     }
//   }
// }));

export default function TopAppBar({backUrl="", children,title: titlePro}:{backUrl?:string, children?:any,title?:string}){
  const classes = useStyles();
  let countNot = useAppSelector(state=>state?.dashBoard?.notificaciones);

  const user = useAppSelector(state => state.auth.user)
  const {whatsappBot, drawerOpen} = useAppSelector(state => state.theme);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {pathname} = useLocation();
  const [title, setTitle] = useState("");
  const urlParams = useParams();
  const Dispatch = useAppDispatch();

  const [anchorEl, setAnchorEl] = React.useState<Element|null>(null);

  const handleClose = () => {
    setAnchorEl(null);
  };



  useEffect(()=>{
    let tt = titlePro

    if(!titlePro) {
      let routePath = pathname;

      for (const [key, value] of Object.entries(urlParams)) {
        if (key !== "*")
          routePath = routePath.replace(value!, ":" + key);
      }


      let routesArray = Routes();
      routesArray.forEach(e => {
        if (!!e.path && e.path.toUpperCase() === routePath.toUpperCase()) {
          tt = e.navbarName ?? "";
        } else if (e.nestedRoutes?.length) {
          let found = e.nestedRoutes.find(n => n.path?.toUpperCase() === routePath.toUpperCase());
          if (found) {
            tt = found.navbarName ?? "";
          } else {
            e.nestedRoutes?.forEach(nestedRoute => {
              let found = nestedRoute.nestedRoutes?.find(n => n.path?.toUpperCase() === routePath.toUpperCase());
              if (found) tt = found.navbarName ?? "";
            })
          }
        }
      })
    }
    setTitle(tt??"")

  },[pathname,urlParams, setTitle, titlePro])

  const getBackUrl = () => {

    if(backUrl) return {path:backUrl};

    let topRoute = null;
    let routePath = pathname;
    for (const [key, value] of Object.entries(urlParams)) {
      if(key !== "*")
        routePath = routePath.replace(value!,":"+key);
    }

    let routesArray = Routes();
    routesArray.forEach(e=>{
      if(e.nestedRoutes?.length){
        let found = e.nestedRoutes.find(n=>n.path?.toUpperCase() === routePath.toUpperCase());
        if(found && e.path){
          topRoute = e
        }else{
          e.nestedRoutes.forEach(nestedRoute=>{
            if(nestedRoute.nestedRoutes?.length){
              let found = nestedRoute.nestedRoutes.find(n=>n.path?.toUpperCase() === routePath.toUpperCase());
              if(found && nestedRoute.path) topRoute = nestedRoute;
            }
          })
        }
      }
    })


    return topRoute;

  };
  const topRoute = getBackUrl();


  return (
      <AppBar className={classes.root + " d-print-none "} >
        <Toolbar className={classes.toolbar}>
          <Box className={classes.appName+(drawerOpen?" hide":"")}>
            {!drawerOpen && <>
              PrestamistAPP <sup style={{fontSize: "12px", paddingLeft: "5px", marginBottom: "9px"}}>3.0</sup>
            </>}
          </Box>
          <IconButton size="small"
                      // color={topRoute?"primary":"default"}
                      className={classes.toggleBtn}
                      onClick={()=>{
                        if(topRoute){
                          navigate(topRoute.path, { replace: true })
                        }else{
                          dispatch(toggleDrawer())
                        }
                      }}
          >

            {topRoute ? <ArrowBack /> : <MenuIcon color={"primary"} />}
          </IconButton>

          <Typography variant="h1" color={title?"primary":"inherit"} noWrap className={classes.title}>
            {translateText(title)}
            {/*{(title)?(*/}
            {/*    <>*/}
            {/*      /!*{topRoute &&*!/*/}
            {/*      /!*  <IconButton size="small" color={"secondary"} onClick={()=>navigate(topRoute.path, { replace: true })}> <ArrowBack/></IconButton>*!/*/}
            {/*      /!*}*!/*/}
            {/*      {title}*/}
            {/*    </>*/}
            {/*):(*/}
            {/*    <>PrestamistAPP</>*/}
            {/*)}*/}

          </Typography>
          <div>
            {/*<IconButton*/}
            {/*    color="inherit"*/}
            {/*    sx={{mr:1}}*/}
            {/*    component={Link}*/}
            {/*    to={"/autorizaciones"}*/}
            {/*>*/}
            {/*  <Badge badgeContent={17} color="error">*/}
            {/*    <NotificationsIcon />*/}
            {/*  </Badge>*/}
            {/*</IconButton>*/}

            {/*<Button onClick={(e)=>setAnchorEl(e.currentTarget)}  endIcon={<KeyboardArrowDown />} size={"small"}>*/}
            {/*  {user?.nombre}*/}
            {/*</Button>*/}


            {/*<Tooltip title="Menu">*/}
            {/*  <IconButton*/}
            {/*      onClick={(e)=>setAnchorEl(e.currentTarget)}*/}
            {/*      size="small"*/}
            {/*      sx={{ ml: 2 }}*/}
            {/*      aria-controls={!!anchorEl ? 'account-menu' : undefined}*/}
            {/*      aria-haspopup="true"*/}
            {/*      aria-expanded={!!anchorEl ? 'true' : undefined}*/}
            {/*  >*/}
            {/*    <Avatar sx={{ width: 32, height: 32 }}>*/}
            {/*      <Person fontSize={"small"} />*/}
            {/*      /!*{user?.nombre?.charAt(0).toUpperCase()}*!/*/}
            {/*    </Avatar>*/}
            {/*  </IconButton>*/}
            {/*</Tooltip>*/}


            {children ?(
                children
            ):(
                <>
                  {hasPermissionTo(PERSMISOS.notificaciones) &&
                        <Badge anchorOrigin={{
                                  vertical: 'top',
                                  horizontal: 'left',
                               }} color="secondary"
                               badgeContent={countNot}
                               sx={{
                                 marginRight: "10px",
                               }}
                        >
                          <IconButton size={"small"}  onClick={(event)=>countNot? Dispatch(toggleNotifSide()):navigate("/notificaciones")} sx={{
                            padding: "3px",
                            border: "1px solid #bdbdbd",
                            borderRadius: "6px",
                          }}>
                            {countNot ? <NotificationsActiveOutlined/> : <NotificationsNone />}
                          </IconButton>

                        </Badge>
                  }
                  {hasModule(MODULO_USUARIO.whatsappBot) &&
                    <Chip className={classes.accountBtn+" "+ (whatsappBot?"active":"")}
                          avatar={<Avatar alt={user?.nombre} variant={"square"}>
                            <WhatsApp fontSize={"small"} />
                          </Avatar>}
                          label={"WhatsApp"}
                          variant="outlined"
                          onClick={()=>dispatch(setOpenWsBotModal({open:true}))}

                    />
                  }
                </>
            )}

            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}

                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                onClick={handleClose}
            >
              <MenuItem component={Link} to="/perfil">
                <ListItemIcon>
                  <PersonOutline fontSize="small" />
                </ListItemIcon>
                <ListItemText>{Strings.perfil}</ListItemText>
              </MenuItem>
              <MenuItem className={whatsappBot?"text-blue-deep":""} onClick={()=>dispatch(setOpenWsBotModal({open:true}))}>
                <ListItemIcon>
                  <WhatsApp fontSize="small" />
                </ListItemIcon>
                <ListItemText>WhatsApp bot</ListItemText>
              </MenuItem>
              <Divider />
              <MenuItem className='text-red-deep' onClick={()=>Dispatch(userLogout())}>
                <ListItemIcon>
                  <ExitToApp fontSize="small" />
                </ListItemIcon>
                <ListItemText>{Strings.cerrarSesion}</ListItemText>
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
  );
}


// import React from 'react';
// import { connect } from 'react-redux';
// import makeStyles from '@mui/styles/makeStyles';
// import {Toolbar, Typography, useMediaQuery,IconButton} from '@mui/material';
// import {Menu as MenuIcon ,ArrowBack} from '@mui/icons-material';
// import {toggleDrawer} from "../redux/reducers/themeReducer";
// import AppBar from '@mui/material/AppBar';
// import {useLocation, useNavigate, useParams} from "react-router-dom";
// import Routes from "../routes";
//
//
// const useStyles = makeStyles(theme => ({
//   root: {
//     position: 'fixed',
//     width: "100%",
//     boxShadow: "none",
//   },
//   toolbar:{
//     padding: "0px "+theme.spacing(2),
//   },
//   under:{
//     boxShadow: "none",
//     [theme.breakpoints.up('md')]: {
//       top:50,
//       padding: "7px 4px",
//       width: "inherit",
//       backgroundColor: "white",
//       borderBottom: "1px solid rgba(0,0,0,0.1)",
//       color: "inherit",
//       "& + .contentInner":{
//         marginTop: 65
//       },
//     },
//     [theme.breakpoints.down('md')]: {
//       "& *":{
//         outline: "none",
//         border:"none",
//         color: theme.palette.common.white,
//       },
//       "& option":{
//         color: theme.palette.common.black,
//
//       }
//     },
//
//   },
//   toggleBtn:{
//     marginRight:theme.spacing(2),
//     [theme.breakpoints.up('md')]: {
//       cursor:"pointer"
//       //display: "none",
//     },
//   },
//   title: {
//     display: "flex",
//     alignItems: "center",
//     flex: 1,
//     fontSize:"1.25rem",
//     fontWeight: 400,
//     textTransform:"capitalize",
//     "& button":{
//       marginRight: theme.spacing(1),
//     }
//   }
// }));
// function TopAppBar({title,toggleDrawer,children}){
//   const classes = useStyles();
//   const navigateTo = useNavigate();
//   const location = useLocation();
//
//   const UrlParams = useParams();
//
//
//   const smVewport = useMediaQuery((theme)=>theme.breakpoints.down('md'));
//
//   const getBackUrl = () => {
//     let topRoute = null;
//
//     let pathname = location.pathname;
//
//     for (const [key, value] of Object.entries(UrlParams)) {
//       pathname = pathname.replace(value,":"+key)
//     }
//     let routesArray = Routes();
//     routesArray.forEach(e=>{
//       if(e.nestedRoutes?.length && e.path){
//         let found = e.nestedRoutes.find(n=>n.path.toUpperCase() === pathname.toUpperCase());
//
//         if(found) topRoute = e;
//       }
//     })
//     return topRoute;
//
//   };
//   const topRoute = getBackUrl();
//
//       return (
//         <AppBar className={classes.root + " d-print-none " + (title?classes.under: "")}>
//           <Toolbar className={classes.toolbar}>
//             {(!title || (smVewport && !topRoute)) && <MenuIcon onClick={toggleDrawer} className={classes.toggleBtn}/> }
//
//             <Typography variant="h1" color={title?"secondary":"inherit"} noWrap className={classes.title}>
//               {(title)?(
//                   <>
//                     {topRoute &&
//                       <IconButton size="small" color={"secondary"} onClick={()=>navigateTo(topRoute.path, {replace:true})}> <ArrowBack/></IconButton>
//                     }
//                     {title}
//                   </>
//               ):(
//                  <>PrestamistAPP</>
//               )}
//
//             </Typography>
//             {children}
//           </Toolbar>
//         </AppBar>
//       );
// }
// const mapStateToprops = (state) => ({
//   drawerOpen: state.theme.drawerOpen
// })
// export default connect(mapStateToprops,{toggleDrawer})(TopAppBar);
//
